import {Box} from "@mui/material"
import {type FC, type CSSProperties} from "react"
import {ChevronViewBioIcon} from "../../../assets"
import Author from "../author/Author"

type Props = {
  style?: CSSProperties
  expertId: string
}

const ViewBio: FC<Props> = (props) => {
  const {expertId} = props
  const style: React.CSSProperties = {
    ...props.style,
  }

  return (
    <Author authorId={expertId} origin="Find an Expert">
      <Box
        style={{...style}}
        sx={{
          ":hover > div": {
            borderBottom: "2px solid #053747",
          },
          ":active > div": {
            borderBottom: "2px solid #053747",
          },
        }}
      >
        <Box
          height={"21px"}
          sx={{
            borderBottom: "1px solid #053747",
          }}
        >
          <span>View bio</span>
        </Box>
        <ChevronViewBioIcon />
      </Box>
    </Author>
  )
}

export default ViewBio
